.loaderOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: calc(var(--toast) - 1);
}

.transparentOverlay {
  background: rgba(255, 255, 255, 0);
  pointer-events: none;
}

.loader {
  border: 8px solid var(--loader-gray);
  border-top: 8px solid var(--loader-blue);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
